import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import "./HomeAbout.css";

export default function HomeAbout() {
  return (
    <section
      className="home-about-section"
      aria-labelledby="about-alutuff-heading"
    >
      <Container fluid>
        <Container className="home-about-content-div">

          {/* Text Content */}
          <header className="home-about-text-div">
            <h2
              id="about-alutuff-heading"
              className="section-heading"
            >
              About Alutuff
            </h2>

            <h3 className="page-text">
              Engineering Better ACP Solutions for Modern Architecture
            </h3>

            <p className="page-text">
              At Alutuff, we manufacture high-performance Aluminium Composite
              Panels (ACP Sheets) designed for modern architectural and building
              applications. With over a decade of industry experience, our
              integrated manufacturing facility in Bareilly, Uttar Pradesh,
              spans 5 lakh sq. ft. and is built to support consistent quality,
              precision, and large-scale production.
            </p>

            <p className="page-text">
              Our ACP panels are engineered for a wide range of applications,
              including building facades, exterior cladding, interior walls,
              commercial spaces, residential projects, and architectural
              installations. From fire-retardant solutions to weather-resistant
              finishes, every panel is developed with a focus on safety,
              durability, aesthetics, and long-term performance.
            </p>

            <p className="page-text">
              We combine modern manufacturing capabilities with stringent
              quality standards to deliver ACP sheets that give architects,
              builders, and designers greater freedom to create distinctive
              spaces.
            </p>

            <p className="page-text">
              Proudly manufactured in India, Alutuff is committed to building
              reliable ACP solutions that bring together engineering, design,
              and lasting performance.
            </p>

            <Link
              to="/about"
              className="pink-button"
              aria-label="Learn more about Alutuff"
              style={{ textDecoration: 'none', display: 'inline-block' }}
            >
              View More
            </Link>
          </header>

          {/* Image */}
          <div className="home-about-img1-div">
            <img
              className="home-about-img1"
              src="/static/media/home-about2.1ab3f511bb4b928ff0bd.jpg"
              alt="Alutuff ACP manufacturing facility and Aluminium Composite Panel production"
              loading="lazy"
              width="540"
              height="360"
            />
          </div>

        </Container>
      </Container>
    </section>
  );
}
